const languages = {
  FR: 'fr',
};

export default languages;
